{
  "manager": {
    "invoiceList": {
      "colInvoiceNumber": "Invoice #",
      "colOrganization": "Organization",
      "colUser": "User",
      "colDueDate": "Due Date",
      "colTotal": "Total",
      "colStatus": "Status",
      "removeAssociation": "Remove Association"
    },
    "inputInvoiceSearch": {
      "placeholder": "Search invoices",
      "selectedLabel": "Selected invoice:",
      "searchError": "Could not search invoices. Try again later or contact support."
    },
    "invoiceItemTimeBreakdown": {
      "timeBreakdown": "TIME BREAKDOWN",
      "hours": "Hours",
      "quantity": "Quantity",
      "required": "Required",
      "rateHour": "Rate/hour",
      "total": "Total",
      "minutes": "Minutes",
      "forLabel": "for",
      "auto": "Auto",
      "removing": "Removing...",
      "removeMinutes": "Remove Minutes",
      "adding": "Adding...",
      "addMinutes": "Add Minutes",
      "addMinutesDescription": "Add minutes to this booking",
      "amountLabel": "Amount",
      "rateMin": "Rate/min"
    },
    "modalAssociateInvoice": {
      "title": "Associate Invoice",
      "okTitle": "Associate",
      "description": "Search for an existing invoice by number or recipient, select it, then click Associate to link it with this booking."
    },
    "formInvoiceItemEditor": {
      "itemableRequired": "This field is required.",
      "descriptionTooLong": "Too many characters. Must be less than 500.",
      "descriptionPlaceholder": "Enter a description for your invoice item",
      "descriptionHint": "Optional. Must be less than 500 characters.",
      "bookingBreakdownFallback": "Booking time breakdown goes here",
      "quantityRequired": "This field is required and must be at least 1.",
      "quantityHint": "Whole numbers only.",
      "amountRequired": "This field is required and must be at least {'$'}0.50.",
      "amountHint": "Minimum {'$'}0.50"
    },
    "invoiceItemActions": {
      "lockedTooltip": "Invoice items cannot be edited once invoice is finalized",
      "editItem": "Edit item",
      "deleteItem": "Delete item"
    },
    "invoiceItemAmount": {
      "perHour": "/hr",
      "flatRate": "Flat rate:",
      "totalFractional": "Total for fractional time"
    },
    "invoiceItemDescription": {
      "perHour": "/hr",
      "flatRate": "Flat rate"
    },
    "invoiceItemProduct": {
      "booking": "Booking",
      "product": "Product"
    },
    "invoiceItemQuantity": {
      "flatRate": "Flat rate"
    },
    "tableInvoiceItemDisplay": {
      "validationErrorsTitle": "This item has validation errors",
      "productRequiredTitle": "Product is required",
      "pleaseSelectProduct": "Please select a product",
      "descriptionTooLongTitle": "Description is too long (max 500 characters)",
      "quantityRequired": "Required and must be a whole number",
      "minAmount": "Min {'$'}0.50",
      "editorSlotFallback": "Editor component should be provided via slot",
      "selectProduct": "Select Product",
      "unknownProduct": "Unknown Product"
    },
    "tableInvoiceItems": {
      "loadingItems": "Loading invoice items...",
      "processingBookings": "Processing booking items...",
      "colProduct": "Product",
      "colDescription": "Description",
      "colQuantity": "Quantity",
      "colAmount": "Amount",
      "colTotal": "Total",
      "colApplyTax": "Apply Tax",
      "colIsDeposit": "Is Deposit",
      "subtotal": "Subtotal",
      "tax": "Tax",
      "addItem": "Add Item"
    },
    "invoiceCreate": {
      "pageTitle": "Create Invoice",
      "sectionRecipient": "Invoice Recipient",
      "selectRecipientType": "Select recipient type",
      "ownerRequired": "Invoice must be associated with a user or organization.",
      "enableOverdueReminders": "Enable Overdue Reminders",
      "overdueRemindersHint": "When enabled, the recipient will receive reminder emails if this invoice becomes overdue. This setting can be changed after the invoice is created.",
      "enableAccountLocking": "Enable Account Locking",
      "accountLockingHint": "When enabled, the member's account will be locked if this invoice becomes overdue. This setting can be changed after the invoice is created.",
      "sectionDetails": "Invoice Details",
      "descriptionLabel": "Invoice Description *",
      "descriptionMaxHint": "Max 500 characters.",
      "descriptionInvalid": "This field is required and must be 500 characters or less.",
      "paymentCollectionLabel": "Payment Collection *",
      "requiredFeedback": "This field is required.",
      "dueDateOption": "Due Date",
      "dueDateOptionHint": "Select this option if you want to set a due date or create a payment plan later.",
      "chargeImmediately": "Charge Immediately",
      "noPaymentInfo": "This user or organization has no payment information on file so they cannot be charged immediately.",
      "selectOwnerFirst": "A member or organization must be selected first before determining payment collection.",
      "dueDateLabel": "Due Date *",
      "paymentMethodsLabel": "Allowed Payment Methods (Optional)",
      "creditCard": "Credit Card",
      "new": "New",
      "preAuthDebit": "Pre-authorized Debit",
      "padFeesLead": "PAD payments have significantly",
      "padFeesBold": "lower processing fees",
      "padFeesTrail": "than credit cards. Note that funds may take 3-5 business days to clear after payment has been initiated.",
      "padLimitWarning": "Pre-authorized Debit is not available for invoices over {'$'}10,000.",
      "sectionBookingAssociations": "Booking Associations",
      "bookingIdLabel": "Associated Booking ID (Optional)",
      "bookingIdHint": "Entering the booking ID will automatically populate the item, hour, and price associated with the booking.",
      "bookingIdInvalid": "Must be a numeric value and a booking must exist with that value.",
      "bookingIdPlaceholder": "Enter a Booking ID",
      "bookingRequestIdLabel": "Associated Booking Request ID (Optional)",
      "bookingRequestIdHint": "Entering the booking request ID will automatically populate the item, hour, and price associated with the booking request.",
      "bookingRequestIdPlaceholder": "Enter a Booking Request ID",
      "saveInvoice": "Save Invoice",
      "vChoiceRequired": "A invoice recipient is required",
      "vDescriptionRequired": "An invoice description is required",
      "vDescriptionMaxLength": "Invoice description must be 500 characters or less",
      "vItemRequired": "Invoice item must have a product or facility selected",
      "vAmountRequired": "Amount is required",
      "vAmountMin": "Amount must be at least 0.5",
      "vQuantityRequired": "Quantity is required",
      "vQuantityMin": "Quantity must be at least 1",
      "vQuantityInteger": "Quantity must be an integer",
      "vItemDescriptionMaxLength": "Description cannot exceed 500 characters",
      "vDueDateRequired": "Due date is required",
      "vPaymentCollectionRequired": "Payment collection is required",
      "invoiceCreatedToast": "Invoice created!",
      "genericError": "Something went wrong. Try again later or contact support."
    },
    "invoiceIndex": {
      "title": "Invoices"
    },
    "invoiceShow": {
      "archivedTitle": "This invoice has been archived.",
      "archivedDescription": "Archived invoices become irreversibly voided and cannot be unarchived or modified.",
      "createdLabel": "Created",
      "finalizeAndEmail": "Finalize & Email Invoice",
      "finalizeNoEmail": "Finalize & Do Not Email",
      "markPaid": "Mark Paid",
      "issueRefund": "Issue Refund",
      "clone": "Clone",
      "archiveInvoice": "Archive Invoice",
      "recipientDetailsHeader": "RECIPIENT DETAILS",
      "associatedBookingIds": "Associated Booking IDs",
      "associatedBookingRequestIds": "Associated Booking Request IDs",
      "associateBooking": "Associate Booking",
      "invoiceDetailsHeader": "INVOICE DETAILS",
      "invoiceItemsHeading": "Invoice Items",
      "itemsModifiableHint": "Items can be modified until the invoice is sent",
      "paymentScheduleHeading": "Payment Schedule",
      "paymentScheduleHint": "Set a single due date or split this invoice into multiple payments.",
      "paymentScheduleLocked": "Payment schedule is locked because the invoice is {status}.",
      "statusArchived": "archived",
      "statusFinalized": "finalized",
      "singleDueDateButton": "Single Due Date",
      "paymentPlanButton": "Payment Plan",
      "dueDate": "Due Date",
      "selectDueDatePlaceholder": "Select due date",
      "saveDueDate": "Save Due Date",
      "singlePaymentDueDate": "Single Payment Due Date",
      "paymentStatusLabel": "Payment Status:",
      "paidInFull": "Paid in Full",
      "partiallyPaid": "Partially Paid",
      "partiallyRefunded": "Partially Refunded",
      "fullyRefunded": "Fully Refunded",
      "paidLabel": "Paid",
      "refundedLabel": "Refunded",
      "netPaidLabel": "Net paid",
      "addPayment": "Add Payment",
      "autoGeneratePlan": "Auto-Generate Plan",
      "colAmount": "Amount",
      "colDescription": "Description",
      "colStatus": "Status",
      "totalLabel": "Total:",
      "mustEqualTotal": "(Must equal invoice total)",
      "paidSuffix": "paid",
      "remainingSuffix": "remaining",
      "savePaymentPlan": "Save Payment Plan",
      "refundsHeading": "Refunds",
      "markPaidModalTitle": "Mark Invoice as Paid",
      "cannotBeUndone": "This action cannot be undone.",
      "markPaidWarning": "If you mark it as paid but need to change back to “unpaid” you will need to clone the paid invoice and resend.",
      "invoiceLabel": "INVOICE",
      "recipientLabel": "RECIPIENT",
      "amountDueLabel": "AMOUNT DUE",
      "bookingLabel": "BOOKING",
      "bookingRequestLabel": "BOOKING REQUEST",
      "taxPaidLabel": "Tax Paid *",
      "taxPaidInvalid": "Must be 0 or greater.",
      "paymentMethodLabel": "Payment Method *",
      "chequeNumberLabel": "Cheque Number *",
      "customPaymentPlanTitle": "Custom Payment Plan",
      "paymentInstructionsLabel": "Payment Instructions",
      "paymentInstructionsPlaceholder": "Examples: 'Split into 3 equal monthly payments' or 'Collect 25% deposit now, remainder in 60 days'",
      "paymentInstructionsHint": "Describe how you'd like the payments structured. You can specify number of payments, intervals, dates, deposit amounts, or service date grouping. Leave blank for automatic scheduling.",
      "exampleInstructionsLabel": "Example instructions:",
      "hide": "Hide",
      "show": "Show",
      "exampleSplit": "\"Split into 2 equal payments 30 days apart\"",
      "exampleDeposit": "\"50% deposit due now, remainder due before event date\"",
      "exampleServiceMonth": "\"Group by service month, collect March items on March 15\"",
      "exampleMonthly": "\"3 monthly payments starting on the 1st of next month\"",
      "exampleDepositSplit": "\"Collect deposit now, split remaining into 2 payments\"",
      "generateButton": "Generate",
      "tabOverview": "Overview",
      "tabPayments": "Payments",
      "tabNotes": "Notes",
      "pmCreditCard": "Credit Card",
      "pmCheque": "Cheque",
      "pmCash": "Cash",
      "pmDebit": "Debit",
      "pmEtransfer": "E-transfer",
      "vAmountMin": "This field is required and must be at least {'$'}0.50.",
      "vHasValidItems": "At least one invoice item with a selected product is required",
      "sendInvoice": "Send Invoice",
      "resendInvoice": "Resend Invoice",
      "refundIssuedToast": "Refund issued successfully.",
      "refundFailedError": "Refund failed. Check the transaction and try again.",
      "bookingsAssociatedToast": "Bookings associated with invoice.",
      "bookingAssociatedToast": "Booking associated with invoice.",
      "invoiceNotFoundError": "Invoice not found. It may have been deleted or you may not have access to it.",
      "notSpecified": "Not specified",
      "entityInvoice": "Invoice",
      "markedPaidToast": "Invoice marked as paid!",
      "invoiceSentToast": "Invoice sent!",
      "invoiceResentToast": "Invoice resent!",
      "paymentNumber": "Payment {number}",
      "vPlanAmountMismatch": "Payment plan amounts must equal the total invoice amount",
      "vPlanDueDatesRequired": "All payments must have due dates",
      "vPlanUniqueDueDates": "Each payment must have a unique due date",
      "planCreatedToast": "Payment plan created!",
      "planUnexpectedResponseError": "Unexpected server response while generating the payment plan. Please refresh and try again.",
      "planFallbackWarning": "We couldn't apply your instructions — a default plan was generated instead. Adjust it manually or try rewording.",
      "planGeneratedToast": "Payment plan generated!",
      "planGenerateError": "Failed to generate payment plan. Please try again or create a manual plan.",
      "vDueDateRequired": "Due date is required",
      "entitySingleDueDate": "Single due date",
      "statusPaid": "Paid",
      "statusCanceled": "Canceled",
      "statusFailed": "Failed",
      "statusPaymentPending": "Payment Pending",
      "statusOverdue": "Overdue",
      "statusDueNext": "Due Next",
      "statusUpcoming": "Upcoming",
      "remindersEnabledToast": "Overdue reminders enabled",
      "remindersDisabledToast": "Overdue reminders disabled",
      "lockingEnabledToast": "Account will be locked when this invoice becomes overdue",
      "lockingDisabledToast": "Account locking disabled",
      "pageTitle": "Invoice",
      "pluralSuffixUpper": "S"
    },
    "modalEditTransaction": {
      "title": "Edit Transaction",
      "notEditable": "Sorry, this transaction is not editable. Editing is only available for transactions resulting from manual membership assignments or program signups.",
      "noteLabel": "Note:",
      "editableNote": "Only transactions that are created due to manual membership or program assignment can be edited.",
      "amountLabel": "Amount",
      "paymentMethodLabel": "Payment Method",
      "dateOfTransactionLabel": "Date of Transaction"
    },
    "modalTransactionRefund": {
      "title": "Confirm Refund",
      "refundButton": "Refund",
      "emailLabel": "EMAIL",
      "transactionDateLabel": "TRANSACTION DATE",
      "transactionIdLabel": "TRANSACTION ID",
      "paymentMethodLabel": "PAYMENT METHOD",
      "refundAmountLabel": "Refund Amount *",
      "refundReasonLabel": "Refund Reason *",
      "sendNotificationLabel": "Send Notification",
      "sendNotificationText": "Send refund notification to user",
      "percent100": "100%",
      "percent50": "50%",
      "percent25": "25%"
    },
    "createOneTimeCharge": {
      "chargeProcessed": "Charge Processed Successfully!",
      "viewChargeDetails": "You can view your charge details in the",
      "transactionsReport": "transactions report",
      "amountLabel": "Amount *",
      "includeTaxLabel": "Include Tax",
      "receiptEmailLabel": "Receipt Email",
      "receiptEmailDescription": "Optional: A receipt will be sent to this email address.",
      "receiptEmailPlaceholder": "Enter email for receipt",
      "descriptionLabel": "Description *",
      "descriptionPlaceholder": "Enter a description for the charge",
      "summary": "Summary",
      "subtotal": "Subtotal:",
      "taxLine": "Tax ({percent}%):",
      "total": "Total:",
      "processCharge": "Process Charge"
    },
    "chargeIndex": {
      "createCharge": "Create Charge"
    }
  },
  "user": {
    "myInvoicesIndex": {
      "pageTitle": "My Invoices",
      "personalTab": "Personal Invoices",
      "organizationTab": "Organization Invoices"
    }
  }
}
